import { getI18n, type Message } from "@/lib/i18n";

export type Coded = Error & { coded: Message };

export const isMessage = (value: unknown): value is Message =>
  typeof value === "object" && value !== null && typeof (value as { id?: unknown }).id === "string";

export function coded(message: Message): Coded {
  return Object.assign(new Error(getI18n().t(message)), { coded: message });
}

export function codeOf(error: unknown): Message | null {
  const found = typeof error === "object" && error !== null ? (error as { coded?: unknown }).coded : null;
  return isMessage(found) ? found : null;
}

export function errorText(error: unknown, fallback: string): string {
  const code = codeOf(error);
  if (code) return getI18n().t(code);
  return error instanceof Error && error.message ? error.message : getI18n().t(fallback);
}

export async function failure(response: Response, fallback: string): Promise<Error> {
  const data = await response.json().catch(() => null);
  const body: Record<string, unknown> = typeof data === "object" && data !== null ? data : {};
  const code = [body.message, body.code].find(isMessage);
  if (code && getI18n().has(code.id)) return coded(code);
  const text = [body.error, body.detail].find((value): value is string => typeof value === "string" && value !== "");
  return text ? new Error(text) : coded({ id: fallback });
}
